import { useEffect, useMemo, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	StyledBg,
	StyledCaseImage,
	StyledContainer,
	StyledInnerContainer,
	StyledTextContainer,
	StyledTimerNumber,
	StyledWrapper,
} from './Offer.styled';

interface IOfferProps {
	suppressed?: boolean;
}

const Offer = ({ suppressed = false }: IOfferProps) => {
	const offer = useObservable(rage.hud.getOffer());
	const minimapInfo = useObservable(rage.gui.getMinimapInfo());
	const [timeLeft, setTimeLeft] = useState(0);

	useEffect(() => {
		if (!offer) {
			setTimeLeft(0);
			return;
		}

		const totalSeconds = Math.ceil(offer.timer / 1000);
		setTimeLeft(totalSeconds);

		const interval = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					clearInterval(interval);
					rage.hud.setOfferShown();
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [offer]);

	const offerData = useMemo(() => {
		if (!offer) return null;

		return { ...offer };
	}, [offer]);

	const renderDescription = useMemo(() => {
		if (!offerData?.description) return null;

		const discountRegex = /(\d+%)/;
		const match = offerData.description.match(discountRegex);

		if (!match) {
			return offerData.description;
		}

		const parts = offerData.description.split(discountRegex);

		return parts.map((part: string, index: number) => {
			if (discountRegex.test(part)) {
				return (
					<span key={index} style={{ fontWeight: 500, color: '#ffffff' }}>
						{part}
					</span>
				);
			}
			return part;
		});
	}, [offerData]);

	return (
		<StyledWrapper
			$x={minimapInfo.x}
			$bottom={minimapInfo.y + minimapInfo.height}
		>
			<CSSTransition
				in={!!offerData && !suppressed}
				timeout={300}
				classNames="offer"
				unmountOnExit
				appear
			>
				<StyledContainer>
					<StyledBg style={{ backgroundColor: offerData?.color }} />
					<StyledInnerContainer>
						<StyledTextContainer>
							<Text
								style={{
									fontSize: 16,
									fontWeight: 500,
									color: offerData?.color,
								}}
							>
								{offerData?.title}
							</Text>
							<Text
								style={{
									fontSize: 14,
									fontWeight: 400,
									color: 'rgba(255, 255, 255, 0.5)',
								}}
							>
								{renderDescription}
							</Text>
						</StyledTextContainer>
						{/* TODO: Прикрутить унификацию кейсов */}
						<StyledCaseImage />
						<StyledTimerNumber>
							<Text>{timeLeft}</Text>
						</StyledTimerNumber>
					</StyledInnerContainer>
				</StyledContainer>
			</CSSTransition>
		</StyledWrapper>
	);
};

export { Offer };
